import React from 'react';
import PropTypes from 'prop-types';
import GenericPhotoUploader from 'Components/ComponentLibrary/Components/Uncategorized/PhotoUploader';
import { useSurveyContext } from '../../Pages/Survey/SurveyContext';


const PhotoUploader = ({
  className,
}) => {
  const { onboardingStepCollection } = useSurveyContext();
  const [onboardingStepResource] = onboardingStepCollection;

  return <GenericPhotoUploader resource={onboardingStepResource} className={className} />;
};

PhotoUploader.defaultProps = {
  className: '',
};

PhotoUploader.propTypes = {
  className: PropTypes.string,
};

export default PhotoUploader;
